// src/pages/MenuDroneChecklist.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  CircularProgress,
  List,
  ListItemButton,
  ListItemText,
  Button,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Icon } from "@mui/material";
import dayjs from "dayjs";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../api";

export default function MenuDroneChecklist() {
  const navigate = useNavigate();
  const [checklists, setChecklists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    fetchUsernameAndData();
  }, [selectedDate]);

  const fetchUsernameAndData = async () => {
    try {
      setLoading(true);
      const storedUser = localStorage.getItem("user");
      let currentUsername = "";

      if (storedUser) {
        const userData = JSON.parse(storedUser);
        currentUsername = userData.nama || "";
        setUsername(currentUsername);
      } else {
        console.error("Data pengguna tidak ditemukan di localStorage.");
      }

      const res = await axios.get(`${API_URL}/drone-checklists`);
      let filtered = res.data.data.filter(
        (item) => item.supervisor === currentUsername
      );
      if (selectedDate) {
        filtered = filtered.filter(
          (item) =>
            dayjs(item.created_at).format("YYYY-MM-DD") ===
            dayjs(selectedDate).format("YYYY-MM-DD")
        );
      }
      setChecklists(filtered);
    } catch (err) {
      console.error("Gagal memuat checklist drone:", err);
    } finally {
      setLoading(false);
    }
  };

  const getCardStyleByStatus = (status) => {
    let borderColor = "#7eaee6";

    if (status === "Menunggu") {
      borderColor = "#f8a23a";
    } else if (status === "Ditolak") {
      borderColor = "#ff6b6b";
    } else if (status === "Disetujui") {
      borderColor = "#6fcf97";
    }

    return {
      borderLeft: `5px solid ${borderColor}`,
      backgroundColor: "#fff",
      borderRadius: 2,
      padding: "8px 16px",
      marginBottom: 1,
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    };
  };

  return (
    <div className="form-container">
      <header className="app-header">
        <div className="header-content">
          <button className="back-button" onClick={() => navigate("/menu")}>
            <Icon>arrow_back</Icon>
          </button>
          <h1 className="header-title"> Profil Karyawan</h1>
          <div className="header-spacer"></div>
        </div>
      </header>
      <Container sx={{ mt: 4 }}>
        {/* Date Picker */}
        <Paper
          sx={{ p: 1, mb: 2, border: "3px solid #4aabff", borderRadius: 2 }}
        >
          <DatePicker
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            slotProps={{
              textField: {
                fullWidth: true,
                placeholder: "Filter Tanggal",
              },
            }}
            maxDate={dayjs()}
          />
        </Paper>

        {/* Data List */}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <CircularProgress />
          </Box>
        ) : checklists.length === 0 ? (
          <Typography sx={{ textAlign: "center", mt: 3, color: "#999" }}>
            Tidak ada data tersedia
          </Typography>
        ) : (
          <List>
            {checklists.map((item) => (
              <ListItemButton
                key={item.id}
                sx={getCardStyleByStatus(item.status)}
                onClick={() => navigate(`/detail-checklist-drone/${item.id}`)}
              >
                <ListItemText
                  primary={
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "0.95rem" }}
                    >
                      {item.lokasi}
                    </Typography>
                  }
                  secondary={
                    <>
                      <Typography
                        component="span"
                        sx={{
                          display: "block",
                          fontSize: "0.8rem",
                          color: "text.secondary",
                        }}
                      >
                        {dayjs(item.created_at).format("DD MMMM YYYY")}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          display: "block",
                          fontSize: "0.75rem",
                          color: "text.primary",
                        }}
                      >
                        Pilot: {item.pilot}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          display: "block",
                          fontSize: "0.75rem",
                          color: "text.primary",
                        }}
                      >
                        Status: {item.status}
                      </Typography>
                    </>
                  }
                />
              </ListItemButton>
            ))}
          </List>
        )}

        {/* Hapus filter */}
        {selectedDate && (
          <Button sx={{ mt: 1 }} onClick={() => setSelectedDate(null)}>
            Hapus filter tanggal
          </Button>
        )}
      </Container>
    </div>
  );
}
